import { colors, space } from '@ardoq/design-tokens';
import styled from 'styled-components';

export const ChipsSeparator = styled.div.attrs({ 'aria-hidden': 'true' })`
  border-left: 1px solid ${colors.borderAction};
  align-self: stretch;
  margin: ${space.xsmall} 0;
`;
